module.exports = __webpack_public_path__ + "2ff2e7045fe085e07683fd8151a801da.svg";